import { Requester } from './Requester';
import { IUserDocumentPopulated } from '../types';

export const GetUserById = async ({ userId }: { userId: string }): Promise<IUserDocumentPopulated | null> => {
    try {
        const response = await Requester<{ user: IUserDocumentPopulated | boolean } | null>({
            path: `users/${userId}`,
            method: 'GET'
        });

        return response && 'user' in response && response.user !== false
            ? (response.user as IUserDocumentPopulated)
            : null;
    } catch (e) {
        console.error('Get user request failed');
        return Promise.reject(e);
    }
};
